import type { Component } from 'vue'

export interface ActionDetailBlock {
  key: string
  component: Component
}

const blocks = new Map<string, ActionDetailBlock>()

export function registerActionDetailBlock(block: ActionDetailBlock): void {
  blocks.set(block.key, block)
}

export function actionDetailBlocks(): ActionDetailBlock[] {
  return [...blocks.values()]
}

export function resetActionDetailBlocks(): void {
  blocks.clear()
}
